import {ISars} from '../monitor.interface';

export const upcomingCaseDeadlinesMock: ISars = {
  data: {
    total: 12,
    categories: [
      {
        name: 'upcoming',
        items: [
          {
            name: 'AML-113277',
            value: 'Due in 8 hours',
            tags: [
              {
                name: 'DORMANT PARTY',
                type: 'dormant'
              },
              {
                name: 'STRUCTURING',
                type: 'structuring'
              },
              {
                name: 'FLOW-THROUGH-2',
                type: 'flow'
              },
              {
                name: 'FLOW-THROUGH-3',
                type: 'flow'
              },
              {
                name: 'FLOW-THROUGH-4',
                type: 'flow'
              }
            ]
          },
          {
            name: 'AML-113987',
            value: 'Due in 3 days',
            tags: [
              {
                name: 'DORMANT PARTY',
                type: 'dormant'
              }
            ]
          },
          {
            name: 'AML-114837',
            value: 'Due in 56 days',
            tags: [
              {
                name: 'STRUCTURING',
                type: 'structuring'
              },
              {
                name: 'FLOW-THROUGH',
                type: 'flow'
              }
            ]
          },
          {
            name: 'AML-223277',
            value: 'Due in 3 hours',
            tags: [
              {
                name: 'STRUCTURING',
                type: 'structuring'
              },
              {
                name: 'FLOW-THROUGH',
                type: 'flow'
              }
            ]
          },
          {
            name: 'AML-223987',
            value: 'Due in 3 hours',
            tags: [
              {
                name: 'FLOW-THROUGH',
                type: 'flow'
              }
            ]
          },
          {
            name: 'AML-224837',
            value: 'Due in 3 days',
            tags: [
              {
                name: 'STRUCTURING',
                type: 'structuring'
              },
              {
                name: 'FLOW-THROUGH',
                type: 'flow'
              }
            ]
          },
          {
            name: 'AML-334837',
            value: 'Due in 6 days',
            tags: [
              {
                name: 'DORMANT PARTY',
                type: 'dormant'
              },
              {
                name: 'STRUCTURING',
                type: 'structuring'
              },
              {
                name: 'FLOW-THROUGH',
                type: 'flow'
              }
            ]
          },
          {
            name: 'AML-003277',
            value: 'Due in 2 hours',
            tags: [
              {
                name: 'STRUCTURING',
                type: 'structuring'
              },
              {
                name: 'FLOW-THROUGH',
                type: 'flow'
              }
            ]
          },
          {
            name: 'AML-003987',
            value: 'Due in 8 days',
            tags: [
              {
                name: 'FLOW-THROUGH',
                type: 'flow'
              }
            ]
          },
          {
            name: 'AML-004837',
            value: 'Due in 2 hours',
            tags: [
              {
                name: 'DORMANT PARTY',
                type: 'dormant'
              },
              {
                name: 'STRUCTURING',
                type: 'structuring'
              },
              {
                name: 'FLOW-THROUGH',
                type: 'flow'
              }
            ]
          }
        ]
      }
    ]
  },
  context: {
    aggregatorFormat: 'day',
    monitorDataType: 'com.jumio.dashboardeventsaggregator.domain.CategoryMonitor',
    dimensionDataType: 'java.lang.Long',
    seriesDataType: 'java.lang.Double',
    startTime: 1661385600000,
    endTime: 1661731200000,
    historyStartTime: 1629849600000,
    historyEndTime: 1630195200000,
    comparisonPeriodLabel: 'vs Previous Period (2021-08-25 - 2021-08-29)',
    durationInaggregatorFormat: 4,
    processedStartTime: 1663640878564,
    processedEndTime: 1663640880372,
    processedTime: 1808
  }
};
